import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider, useAuth } from "./lib/auth";
import { LangProvider } from "./lib/i18n";
import Proyek from "./pages/Proyek";
import HapusData from "./pages/HapusData";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import BarangMasuk from "./pages/BarangMasuk";
import BarangKeluar from "./pages/BarangKeluar";
import Verifikasi from "./pages/Verifikasi";
import CekStock from "./pages/CekStock";
import DataStock from "./pages/DataStock";
import Opname from "./pages/Opname";
import Aktivitas from "./pages/Aktivitas";
import Tonnage from "./pages/Tonnage";
import Revisi from "./pages/Revisi";
import RevisiKeluar from "./pages/RevisiKeluar";
import Retur from "./pages/Retur";
import UjiLapangan from "./pages/UjiLapangan";
import Riwayat from "./pages/Riwayat";
import Users from "./pages/Users";
import AiSearch from "./pages/AiSearch";
import BarcodeDetail from "./pages/BarcodeDetail";
import NotReplicated from "./pages/NotReplicated";

function Guarded() {
  const { user } = useAuth();
  if (user === null) return <div className="boot-loading" data-testid="boot-loading">Memuat... / 加载中...</div>;
  if (user === false) return <Login />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to={user.role === "VENDOR" ? "/keluar" : "/dashboard"} replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/masuk" element={<BarangMasuk />} />
        <Route path="/keluar" element={<BarangKeluar />} />
        <Route path="/verifikasi" element={<Verifikasi />} />
        <Route path="/cek" element={<CekStock />} />
        <Route path="/stockdata" element={<DataStock />} />
        <Route path="/opname" element={<Opname />} />
        <Route path="/activity" element={<Aktivitas />} />
        <Route path="/tonnage" element={<Tonnage />} />
        <Route path="/outrevision" element={<Revisi />} />
        <Route path="/revisi-keluar" element={<RevisiKeluar />} />
        <Route path="/retur" element={<Retur />} />
        <Route path="/uji-lapangan" element={<UjiLapangan />} />
        <Route path="/riwayat" element={<Riwayat />} />
        <Route path="/proyek" element={<Proyek />} />
        <Route path="/hapus" element={<HapusData />} />
        <Route path="/users" element={<Users />} />
        <Route path="/ai-search" element={<AiSearch />} />
        <Route path="/scan/:barcode" element={<BarcodeDetail />} />
        <Route path="/todo/:tab" element={<NotReplicated />} />
        <Route path="*" element={<Navigate to={user.role === "VENDOR" ? "/keluar" : "/dashboard"} replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <LangProvider>
      <BrowserRouter>
        <Guarded />
      </BrowserRouter>
      </LangProvider>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
